
import { useToast } from "@/components/ui/use-toast";
import { fetchSubscriptionStats } from "@/utils/subscriptionUtils";

export const useAdminSubscriptions = (userRole: string | null, setLoadingStripe: (loading: boolean) => void, setStripeSubscriptions: (data: any) => void) => {
  const { toast } = useToast();

  const fetchStripeSubscriptions = async () => {
    if (userRole !== 'admin') {
      return {
        monthly: 0,
        yearly: 0,
        total: 0,
        subscriptions: []
      };
    }
    
    try {
      setLoadingStripe(true);
      console.log("Fetching subscriptions from database...");
      
      const stats = await fetchSubscriptionStats();
      console.log("Successfully fetched subscriptions from database:", stats);
      return stats;
    } catch (error: any) {
      console.error("Error fetching subscriptions from database:", error);
      toast({
        title: "Error",
        description: "Failed to load subscription data: " + (error.message || "Unknown error"),
        variant: "destructive",
      });
      return {
        monthly: 0,
        yearly: 0,
        total: 0,
        subscriptions: []
      };
    } finally {
      setLoadingStripe(false);
    }
  };

  return {
    fetchStripeSubscriptions
  };
};
